import { IResumeContractType, LanguageLocale } from '../../../models';

export class ResumeContractTypeGetters {
  static getName(item: IResumeContractType, locale: LanguageLocale): string {
    if (!item || !item.i18n || item.i18n.length < 1) return '';
    const i18n = item.i18n.find((i) => i.locale === locale);
    return i18n && i18n.name ? i18n.name : '';
  }
}
